import { UserFacilities, UserFacilitiesTree } from "../../redux/models/userFacilities";

export const getUniquePortfoliosValues = (array: UserFacilities[], key: string): any[] => {
    return Array.from(new Set(array.map(item => item.portfolioId)));
  };
  export const getUniquePortfoliosNames = (array: UserFacilities[], key: string): any[] => {
    if(array&&array.length){
        return array?.filter(
              (portfolio, index, self) =>
                index === self.findIndex((p) => p.portfolioId === portfolio.portfolioId)
            );
    }
    else{
      return [];
    }
    
  };

 export const getUniqueRegionsValues = (array: UserFacilities[], key: string): any[] => {
    if(array&&array.length){
        return Array.from(new Set(array?.map(item => item.regionId)));
    }
    else{
      return [];
    }
  };
 export const getUniqueFacilities = (array: UserFacilities[], key: string): any[] => {
  if(array&&array.length){
        return Array.from(new Set(array?.map(item => item.facilityId)));
    }
    else{
      return [];
    }
    
  };

export const getPortfolioTree = (userFacilitiesList:UserFacilities[])=>{
    const uniqueNames = getUniquePortfoliosValues(userFacilitiesList, 'portfolioId');
    const uniqueRegionNames = getUniqueRegionsValues(userFacilitiesList, 'regionId');
    let treeViewObject: UserFacilitiesTree =  {
        facilityId: 0, facilityName: "Facility", children: [],
        userId: 0,
        portfolioId: 0,
        portfolioName: "",
        regionId: 0,
        regionName: ""
      };
  uniqueNames.forEach((e,ip)=>{
        //Portfolios
        const portfolioObj =userFacilitiesList.filter((p)=>p.portfolioId==e);
        let pObject:UserFacilitiesTree = {
          portfolioId: e, portfolioName: portfolioObj[0].portfolioName,
          userId: 0,
          facilityId: e,
          facilityName: portfolioObj[0].portfolioName,
          regionId: 0,
          regionName: "",
          children:[]
        }
        uniqueRegionNames.forEach((r,ir)=>{
          //Regions
          if(r){
            const rList= userFacilitiesList.filter((u)=>u.portfolioId==e&&u.regionId==r)
            if(rList.length){
              let rObject:UserFacilitiesTree = {
                portfolioId: e, portfolioName: portfolioObj[0].portfolioName,
                userId: 0,
                facilityId: r,
                facilityName: rList[0].regionName,
                regionId: rList[0].regionId,
                regionName: rList[0].regionName,
                children:rList
              }
              pObject?.children?.push(rObject);
            }
            
          }
        
      })
      treeViewObject?.children?.push(pObject);
      
      })
    return treeViewObject;
}

export const getDefaultPortfolios = (userFacilitiesList:UserFacilities[],type:string)=>{
    const uniqueNames = getUniquePortfoliosValues(userFacilitiesList, 'portfolioId');
    const uniqueRegionNames = getUniqueRegionsValues(userFacilitiesList, 'regionId');
    const uniqueFacilities = getUniqueFacilities(userFacilitiesList, 'facilityId');
    if(type=='tree')
        return [0,...uniqueNames,...uniqueRegionNames];
    return [0,...uniqueNames,...uniqueRegionNames,...uniqueFacilities];
}
export const getDefaultPortfoliosNames = (userFacilitiesList:UserFacilities[],type:string)=>{
  const uniqueNames = getUniquePortfoliosNames(userFacilitiesList, 'portfolioId');
  return uniqueNames;
}